import { mixpanel } from './mixpanel';

let initialized = false;
const sampled = import.meta.env.PROD && Math.random() < 0.1;
const firstImageRoutes = new Set<string>();
let currentRoute: string | null = null;
let navigationStart = 0;

export function markNavigation(path: string): void {
  if (currentRoute !== null && currentRoute !== path) navigationStart = performance.now();
  if (currentRoute !== path) firstImageRoutes.delete(path);
  currentRoute = path;
}

export function performanceRoute(path: string): string {
  const parts = path.split('/');
  if (['albums', 'events', 'slideshow', 'tv', 'p', 'join'].includes(parts[1])) {
    return `/${parts[1]}${parts.length > 2 ? '/:id' : ''}`;
  }
  return ['/login', '/', '/insights', '/admin', '/become-a-creator'].includes(path) ? path : '/other';
}

export function reportPerformance(name: string, value: number): void {
  if (!sampled || !Number.isFinite(value)) return;
  mixpanel.track('Performance', { metric: name, value, route: performanceRoute(location.pathname),
    device: innerWidth < 768 ? 'mobile' : 'desktop',
    portal: location.hostname.startsWith('creator.') ? 'creator' : 'viewer' });
}

export function reportFirstThumbnail(): void {
  const route = location.pathname;
  if (firstImageRoutes.has(route)) return;
  if (firstImageRoutes.size >= 64) firstImageRoutes.clear();
  firstImageRoutes.add(route);
  reportPerformance('first_thumbnail_loaded_ms', performance.now() - navigationStart);
}

export function initPerformanceMetrics(): void {
  if (initialized || !sampled) return;
  initialized = true;
  const route = performanceRoute(location.pathname);
  // Buffered observers make idle loading safe; field vitals describe the
  // document navigation, not whichever SPA route is open when reporting.
  const load = () => import('web-vitals').then(({ onLCP, onINP, onCLS }) => {
    const report = (metric: { name: string; value: number; rating: string }) => {
      mixpanel.track('Web Vital', { metric: metric.name, value: metric.value, rating: metric.rating,
        route, device: innerWidth < 768 ? 'mobile' : 'desktop',
    portal: location.hostname.startsWith('creator.') ? 'creator' : 'viewer' });
    };
    onLCP(report); onINP(report); onCLS(report);
  }).catch(() => { /* Metrics must never block application use. */ });
  if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 3000 });
  else setTimeout(load, 1000);
}
